import { Component, OnInit } from '@angular/core';
import { trigger, transition, useAnimation } from '@angular/animations';
import { fadeInDown } from 'ng-animate';
import { OrderPipe } from 'ngx-order-pipe';
import { ApiurlsService } from '../../../services/api-urls/apiurls.service';
import { ApirequestService } from '../../../services/apirequest/apirequest.service';
import { UtilityService } from '../../../services/utilities/utilities.services';
import { MatDialog, Sort } from '@angular/material';
import { ConfirmdialogComponent } from '../../common/dialog/confirmdialog.component';
@Component({
  selector: 'hybse-admin-ibo',
  templateUrl: './ibo.component.html',
  styleUrls: ['./ibo.component.css'],
  animations: [
    trigger('fadeInDown', [transition('* => *', useAnimation(fadeInDown, {
      params: {
        timing: 1,
        a: '-10px'
      }
    }))])
  ],
})
export class IboComponent implements OnInit {
  fadeInDown: any;
  iboList: any[] = [];
  listOfIBO: any[] = [];
  showLoader: boolean = true;
  public limit: number = 50;
  public count: number;
  public offset: number = 0;
  public search: string;
  public filterType: number;
  public errorMessage: string;
  public name: string;
  public ibin: string;
  public market: string;

  //sorting
  order: string = 'companyName';
  reverse: boolean = false;
  sortedCollection: any[];

  constructor(
    private _urls: ApiurlsService,
    private _api: ApirequestService,
    private _utils: UtilityService,
    private dialog: MatDialog,
    private orderPipe: OrderPipe
  ) {
    this.getIBOList();


  }
  ngOnInit() {

    this.sortedCollection = this.orderPipe.transform(this.iboList, this.order);
  }

  getIBOList() {
    let data = {
      offset: this.offset,
      limit: this.limit,
    }
    if (this.search || this.filterType) {
      data['search'] = this.search;
      data['filterType'] = this.filterType;
    }
    this.iboList = [];
    this._api.fetchApiData(this._urls.listIBOUrl, data, 'get').subscribe(
      (data: any) => {
        let resSucc = data.data;
        let resError = data.error;
        if (resSucc != '') {
          this.iboList = resSucc.iboList;
          this.count = data.data.count;
        } else {
          this.iboList = [];
          this.errorMessage = resError['Error Description'];
        }
      },
      error => { },
      () => {
        this.showLoader = false;
      }
    )
  }

  confirmDelete(res) {
    const deleteDialog = this.dialog.open(ConfirmdialogComponent, {
      width: '400px',
      height: '170px',
      data: {
        message: 'Are you sure to delete?'
      }
    });
    deleteDialog.afterClosed().subscribe(
      data => {
        if (data) this.deleteUser(res);
      }
    );
  }

  deleteUser(res) {
    let data = {
      data: {
        idIBOSellorder: res.idIBOSellorder,
        idCompanyStock: res.idCompanyStock
      }
    };
    this._api.fetchApiData(this._urls.deleteIBOUrl, data).subscribe(
      (data: any) => {
        let response = data;
        if (response != 0) this.deleteIboFromList(res);
      },
      error => {

      },
      () => {

      }
    );
  }

  deleteIboFromList(res) {
    this.iboList = this._utils.filterArrayObj(this.iboList, 'idIBOSellorder', res.idIBOSellorder);
  }

  public doSomething(): void {
    if (!this.market && !this.name && !this.ibin) {
      this.filterType = undefined;
      this.search = undefined;
      this.getIBOList();
    }
  }

  public selectedSearch(type: string) {
    if (type === 'companyname') {
      this.filterType = 6;
      this.search = this.name;
    } else if (type === 'ibin') {
      this.filterType = 5;
      this.search = this.ibin;
    } else {
      this.filterType = 7;
      this.search = this.market;
    }
    this.getIBOList();
  }

  setOrder(value: string) {
    if (this.order === value) {
      console.log(this.reverse);
      this.reverse = !this.reverse;
    }
    if (value === "createdAt") {
      this.reverse ? this.filterType = 1 : this.filterType = 2;
      this.getIBOList();
    }
    if (value === 'lockupDate') {
      this.reverse ? this.filterType = 3 : this.filterType = 4;
      this.getIBOList();
    }
    this.order = value;
  }
}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/ibo/ibo.component.ts